import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "../../data";
import { Reveal } from "./Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32 bg-[#0a192f] border-y border-[#bf953f]/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <Reveal>
          <p className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-[#d4af37]">Common Questions</p>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight text-white">
            Answers, <span className="text-gold-gradient italic">upfront.</span>
          </h2>
          <p className="mt-5 font-body font-light text-base md:text-lg leading-relaxed text-white/60">
            Everything families ask us most about coverage, pricing, and how quotes work.
            Still curious? We're one call away.
          </p>
          <Link
            to="/life-insurance#quote"
            data-testid="faq-quote-btn"
            className="btn-sweep mt-8 inline-flex items-center rounded-full bg-gold-metallic px-7 py-3 font-body text-sm font-medium tracking-wide text-black"
          >
            Get My Free Quote
          </Link>
        </Reveal>
      </div>

      <div className="lg:col-span-8">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-5 text-left font-serif-display text-lg md:text-xl text-white hover:text-[#d4af37] hover:no-underline transition-colors [&>svg]:text-[#d4af37]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 font-body font-light text-sm md:text-base leading-relaxed text-white/60">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
